import {inject} from 'aurelia-framework';

function htmlEncode(html) {
  return document.createElement('a').appendChild(
    document.createTextNode(html)).parentNode.innerHTML;
}

@inject(Element)
export class PreserveBreaksCustomAttribute {
  value;

  constructor(element) {
    this.element = element;
  }

  valueChanged() {
    let unEncodedHtml = this.value || "";
    let html = htmlEncode(unEncodedHtml);
    html = html.replace(/\r/g, '').replace(/\n/g, '<br>');
    this.element.innerHTML = html;
  }
}
